<template>
  <div
    class="flex-grow-1 d-flex flex-column"
    :class="[
      display.mdAndUp.value ? 'bg-neutral25' : 'bg-neutral0',
      {'page-transitioning': transitioning}
    ]"
  >
    <v-main class="pt-md-16">
      <BrandButton
        v-if="display.mdAndUp.value && showBackButton"
        icon position="fixed"
        variant="basic" color="neutral900"
        class="bg-neutral0"
        border="0"
        size="large"
        @click="onBackButtonClicked"
        style="top: 16px; left: 16px;"
      >
        <PhArrowLeft class="text-h5" />
      </BrandButton>
      <!-- HACK header is used as extra padding on mobile is to account for iPhone notches -->
      <header v-else-if="display.smAndDown.value" class="bg-neutral0 pt-8 pt-sm-2 px-2 d-flex align-center">
        <BrandButton
          v-if="showBackButton"
          icon variant="basic" color="neutral900"
          class="bg-neutral0"
          border="0"
          @click="onBackButtonClicked"
        >
          <PhArrowLeft class="text-h5" />
        </BrandButton>
        <!-- Centered title set by child pages via focusMobileTitle -->
        <h3
          v-if="focusMobileTitle"
          class="flex-grow-1 text-center text-truncate text-subtitle-1 font-weight-semibold px-2"
          v-text="focusMobileTitle"
        />
        <div v-if="focusMobileTitle && showBackButton" style="width: 40px" />
      </header>

      <v-container class="sheet-container py-0" :style="{'--maxWidth': `${maxWidthDesktop}px`}">
        <v-card flat v-bind="subpageProps" class="subpage-content mt-md-6 py-md-8 mb-6">
          <router-view v-slot="{ Component }" class="route-page">
            <transition
              :name="transitionName"
              mode="out-in"
              @before-leave="onBeforeLeave"
              @after-leave="onAfterLeave"
              @after-enter="onAfterEnter"
            >
              <component :is="Component" />
            </transition>
          </router-view>
        </v-card>
      </v-container>
    </v-main>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useDisplay } from 'vuetify'
import { PhArrowLeft } from '@phosphor-icons/vue'
import { useRouteTransition } from '@/composables/useRouteTransition'
import { useFocusMobileTitle } from '@/composables/useFocusMobileTitle'

// Define props
const props = defineProps({
    backButton: {
      type: [Object, Boolean],
      default: true,
    },
    maxWidthDesktop: {
      type: Number,
      default: 720,
    },
})

// Setup router and route
const router = useRouter()
const route = useRoute()

// Use route transition composable to replace the mixin
const {
  transitionName,
  transitioning,
  onBeforeLeave,
  onAfterLeave,
  onAfterEnter,
} = useRouteTransition()

// Get Vuetify display
const display = useDisplay()

// Mobile title — set by child pages via useFocusMobileTitle composable
const { focusMobileTitle } = useFocusMobileTitle()

// Computed properties
const showBackButton = computed(() => !!props.backButton)

const subpageProps = computed(() => {
  if (display.mdAndUp.value) {
        return {
          class: 'rounded-lg',
          outlined: true,
        }
      }

      return { tile: true }
})

// Methods
const onBackButtonClicked = () => {
  if (props.backButton?.to) {
    const to = props.backButton.to?.(route, {
      // Proxy of 'this' context for backward compatibility
      isExtension: false, // Replace with actual values as needed
      isExtensionPopup: false,
      isDesktop: display.mdAndUp.value,
      isMobile: display.smAndDown.value
    }) ?? props.backButton.to

    // Check if router has backTo method, otherwise fallback to push
    if (typeof router.backTo === 'function') {
      router.backTo(to)
    } else {
      router.push(to)
    }
      } else {
    router.back()
      }
}
</script>

<style lang="scss" scoped>
// .page-transitioning {
//   overflow: hidden;
//   height: 100vh;
// }

.subpage-content {
  border-color: rgb(var(--v-theme-neutral50)) !important;
  background-color: rgb(var(--v-theme-neutral0));

  @media (max-width: 959px) {
    overflow: visible !important;
  }
}

.sheet-container {
  max-width: var(--maxWidth);
}
</style>
